import Api from '@/services/Api'

export default {
    getTranslations() {
        return Api().get('/translations');
    },
    updateTranslationCartons(carton, translationIds) {
        return Api().put('/translations/cartons', { carton, translationIds });
    }
}